import { TFunction } from 'i18next'

import {
  DifficultRoute,
  IFindTicketForm,
} from 'entities/ticket/models/find-ticket/models'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export type ComplexRouteHeaderSegment = {
  dateLabel: string
  routeLabel: string
}

export type ComplexRouteHeaderViewModel = {
  passengersLabel: string
  cabinLabel: string
  segments: ComplexRouteHeaderSegment[]
}

const formatRouteLabel = (direction: DifficultRoute): string => {
  const from = direction.from?.cityIataCode || direction.from?.cityName || ''
  const to = direction.to?.cityIataCode || direction.to?.cityName || ''

  return `${from} –– ${to}`
}

export const prepareComplexRouteHeaderData = (
  form: IFindTicketForm | undefined,
  passengersCount: number,
  cabinNameKey: string | undefined,
  t: TFunction,
): ComplexRouteHeaderViewModel => {
  const directions = form?.directions ?? []

  return {
    passengersLabel: t('pass_count', { count: passengersCount }),
    cabinLabel: t(cabinNameKey || ''),
    segments: directions.map((direction) => ({
      dateLabel:
        dateFormat(direction.date || '', DATE_FORMAT_LIST.DATE_MONTH) || '',
      routeLabel: formatRouteLabel(direction),
    })),
  }
}
